import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { countries, devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the admin user table view.
 * @extends JetView
 */
export default class tableAdminUserView extends JetView {
    /**
     * Configures the datatable for displaying user information.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Type of view
            id: 'datatable', // Unique identifier for the datatable
            css: 'webix_header_border webix_data_border', // CSS classes for styling
            select: true, // Enable row selection
            height: screen.width < 500 ? 405 : 0, // Set height based on screen width
            columns: [
                // Column definitions for the datatable
                { id: 'Id', header: 'Id', width: 60, sort: 'int' }, // Column for user ID
                {
                    id: 'FirstName',
                    header: _('Primer Nombre'), // Localized header for first name
                    width: 120,
                    sort: 'int',
                },
                {
                    id: 'SecondName',
                    header: _('Segundo Nombre'), // Localized header for second name
                    width: 120,
                    sort: 'int',
                },
                {
                    id: 'FirstLastName',
                    header: _('Primer Apellido'), // Localized header for first last name
                    width: 120,
                    sort: 'int',
                },
                {
                    id: 'SecondLastName',
                    header: _('Segundo Apellido'), // Localized header for second last name
                    width: 120,
                    sort: 'int',
                },
                { id: 'Partner', header: _('Partner'), width: 80, sort: 'int' }, // Column for partner information
                {
                    id: 'TypeDocument',
                    header: _('Tipo Documento'), // Localized header for document type
                    width: 130,
                    options: [
                        // Options for document type selection
                        {
                            id: '0',
                            value: _('Cedula Nacional'), // National ID
                        },
                        {
                            id: '1',
                            value: _('Cedula Extranjera'), // Foreign ID
                        },
                        {
                            id: '2',
                            value: _('Pasaporte'), // Passport
                        },
                    ],
                },
                { id: 'Cedula', header: _('Cedula'), width: 130, sort: 'int' }, // Column for ID number
                {
                    id: 'Type',
                    header: _('Tipo'), // Localized header for user type
                    width: 150,
                    options: [
                        // Options for user type selection
                        {
                            id: '0',
                            value: _('Trabajador'), // Worker
                        },
                        {
                            id: '1',
                            value: _('Familiar Trabajador'), // Worker family member
                        },
                        {
                            id: '2',
                            value: _('Usuario'), // User
                        },
                    ],
                },
                {
                    id: 'State',
                    header: _('Estado'), // Localized header for state
                    options: [
                        // Options for state selection
                        { id: 'A', value: _('Activo') }, // Active
                        { id: 'I', value: _('Inactivo') }, // Inactive
                    ],
                },
                {
                    id: 'DateCreated',
                    header: _('Fecha de Creación'), // Localized header for creation date
                    width: 160,
                    sort: 'int',
                },
            ],
            tooltip: true, // Enable tooltips
            math: true, // Enable mathematical operations
            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
            pager: 'pagerA', // Identifier for the pager
            url: devConfig.geturlApi() + 'es/UserManagement/GetBlockedUser', // API endpoint for loading data
        };
    }

    /**
     * Initializes the datatable and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        var url = grid.data.url; // URL for data loading
        var vthis = this; // Reference to the current instance
        var filter = ''; // Filter string for data loading

        // Event listener for filtering data
        this.on(this.app, 'adminUser:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to filter
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter string
        });

        // Event listener for sorting data
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Event listener for adding a new user
        this.on(this.app, 'addUser:button', (filter) => {
            popupAdd.show(); // Show the add user popup
        });

        // Popup configuration for adding a new user
        var popupAdd = webix.ui({
            view: 'window',
            id: 'addwinCasshier', // Unique identifier for the popup
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Añadir Usuario a Bloquear') }, // Label for the popup
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on close
                        },
                    },
                ],
            },
            position: 'center', // Center the popup on the screen
            modal: true, // Make the popup modal
            width: 5000, // Width of the popup
            body: {
                view: 'form', // Form for user input
                id: 'saveform', // Unique identifier for the form
                elements: [
                    // Form elements
                    {
                        view: 'richselect',
                        name: 'TypeDocument', // Name for the document type field
                        localId: 'TypeDocument:combo', // Local identifier for the document type
                        label: _('Tipo'), // Localized label for the field
                        labelPosition: 'top', // Position of the label
                        placeholder: _('Click para seleccionar '), // Placeholder text
                        value: '0', // Default value
                        options: [
                            // Options for document type selection
                            {
                                id: '0',
                                value: _('Cedula Nacional'), // National ID
                            },
                            {
                                id: '1',
                                value: _('Cedula Extranjera'), // Foreign ID
                            },
                            {
                                id: '2',
                                value: _('Pasaporte'), // Passport
                            },
                        ],
                    },
                    {
                        view: 'text',
                        name: 'Cedula', // Name for the ID number field
                        label: _('Cedula'), // Localized label
                        labelWidth: 150, // Width of the label
                        width: 300, // Width of the input field
                        sort: 'int', // Sorting type
                    },
                    {
                        view: 'text',
                        name: 'FirstName', // Name for the first name field
                        label: _('Primer Nombre'), // Localized label
                        labelWidth: 150, // Width of the label
                        width: 300, // Width of the input field
                        sort: 'int', // Sorting type
                    },
                    {
                        view: 'text',
                        name: 'SecondName', // Name for the second name field
                        label: _('Segundo Nombre'), // Localized label
                        labelWidth: 150, // Width of the label
                        width: 300, // Width of the input field
                        sort: 'int', // Sorting type
                    },
                    {
                        view: 'text',
                        name: 'FirstLastName', // Name for the first last name field
                        label: _('Primer Apellido'), // Localized label
                        labelWidth: 150, // Width of the label
                        width: 300, // Width of the input field
                        sort: 'int', // Sorting type
                    },
                    {
                        view: 'text',
                        name: 'SecondLastName', // Name for the second last name field
                        label: _('Segundo Apellido'), // Localized label
                        labelWidth: 150, // Width of the label
                        width: 300, // Width of the input field
                        sort: 'int', // Sorting type
                    },
                    {
                        view: 'richselect',
                        name: 'Type', // Name for the user type field
                        localId: 'Type:combo', // Local identifier for the user type
                        label: _('Tipo'), // Localized label
                        labelPosition: 'top', // Position of the label
                        placeholder: _('Click para seleccionar '), // Placeholder text
                        value: '0', // Default value
                        options: [
                            // Options for user type selection
                            {
                                id: '0',
                                value: _('Trabajador'), // Worker
                            },
                            {
                                id: '1',
                                value: _('Familiar Trabajador'), // Worker family member
                            },
                            {
                                id: '2',
                                value: _('Usuario'), // User
                            },
                        ],
                    },
                    {
                        view: 'richselect',
                        name: 'State', // Name for the state field
                        localId: 'regions:combo', // Local identifier for the state
                        label: "<span class='icon-state'></span>" + _('Estado'), // Localized label with icon
                        labelPosition: 'top', // Position of the label
                        placeholder: _('Click para seleccionar '), // Placeholder text
                        value: 'A', // Default value
                        options: [
                            // Options for state selection
                            {
                                id: 'A',
                                value: _('Activo'), // Active
                            },
                            {
                                id: 'I',
                                value: _('Inactivo'), // Inactive
                            },
                        ],
                    },
                    {
                        view: 'richselect',
                        name: 'Partner', // Name for the partner field
                        localId: 'regions:combo', // Local identifier for the partner
                        label: _('Partner'), // Localized label
                        labelPosition: 'top', // Position of the label
                        placeholder: _('Click para seleccionar '), // Placeholder text
                        value: profile.PartnerSelected, // Default value from profile
                        options: profile.Partners, // Options from profile
                    },
                    {
                        cols: [
                            // Button layout
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the popup on cancel
                                },
                            },
                            {
                                view: 'button',
                                type: 'form', // Button type for form submission
                                value: _('Guardar'), // Save button
                                click: function ($e) {
                                    var values = $$('saveform').getValues(); // Get form values
                                    webix
                                        .ajax() // AJAX request to save user
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'es/UserManagement/SaveUserBlocked', // API endpoint for saving user
                                            values,
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Error! ')); // Show error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    text = JSON.parse(text); // Parse response
                                                    if (text.HasError) {
                                                        webix.message(_('Error! ')); // Show error message if any
                                                    } else {
                                                        webix.message(_('Usuario Agregado')); // Show success message
                                                    }
                                                    grid.clearAll(); // Clear grid data
                                                    grid.load(
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid with updated data
                                                    );
                                                },
                                            },
                                        );
                                    $$('saveform').setValues(
                                        $$('saveform').getCleanValues(), // Reset form values
                                    );
                                    this.getTopParentView().hide(); // Hide the popup after saving
                                },
                            },
                        ],
                    },
                ],
            },
        });
    }
}

// FILE DOCUMENTED
